"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _userAvatarModule = _interopRequireDefault(require("./user-avatar.module.scss"));
var UserAvatar = function UserAvatar(_ref) {
  var fullName = _ref.fullName,
    className = _ref.className;
  var initials = (0, _react.useMemo)(function () {
    return fullName.split(' ').map(function (namePart) {
      return namePart[0];
    }).filter(function (_, index) {
      return index < 2;
    }).join('');
  }, [fullName]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_userAvatarModule.default['user-avatar'], className)
  }, initials);
};
exports.UserAvatar = UserAvatar;